import { Injectable } from '@angular/core';
import { ApiService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService extends ApiService {
  async getEmployeeByEmployeeId(employeeId: string): Promise<any> {
    const response = await this.get<{ result: any }>(
      `employee/${encodeURIComponent(employeeId)}`
    );
    return response.result;
  }
}
